import { useEffect } from 'react'
import { axiosClient } from 'net/ajax'
import { BroadcastChannel } from 'broadcast-channel'
import { SHOW_MODAL_KEY } from 'components/dashboard/home/components/TrialExpirationCountdown'
import { STORE_USER_ID } from 'utils/userIdMonitor'

const LOGOUT_EVENT = 'LOGOUT'

const logoutChannel = new BroadcastChannel('logout')

export const authBroadcastEvents = {
    logout: (redirectTo) => logoutChannel.postMessage({ type: LOGOUT_EVENT, redirectTo }),
}

export const useAuthBroadcastObserver = () => {
    useEffect(() => {
        if (window.document.getElementById('cypress-enabled')) return

        logoutChannel.onmessage = (data) => {
            switch (data.type) {
                case LOGOUT_EVENT:
                    window.location = data.redirectTo || '/'
                    break
                default:
                    break
            }
        }

        return () => {
            logoutChannel.close()
        }
    }, [])
}

export const onLogout = (event) => {
    event.preventDefault()

    axiosClient
        .request({
            url: '/user/sign_out',
            method: 'DELETE',
        })
        .then((result) => {
            if (result.status === 200 && result.data) {
                const redirectTo = result.data.redirect_to || '/'
                authBroadcastEvents.logout(redirectTo)

                localStorage.removeItem(STORE_USER_ID)

                if (localStorage.getItem(SHOW_MODAL_KEY)) {
                    localStorage.removeItem(SHOW_MODAL_KEY)
                }

                window.location.href = redirectTo
            }
        })
        .catch((error) => {})

    return false
}
